import { useState } from 'react';
import { supabase } from './supabaseClient';

const NAVY = '#0C2340';
const GOLD = '#C5A25D';
const WHITE = '#FFFFFF';
const SLATE = '#6B7280';
const BORDER = '#E5E1D8';
const RED = '#B91C1C';

export default function LoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSignIn = async (e) => {
    e.preventDefault();
    if (!supabase) {
      setError('Supabase is not configured. Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your .env file.');
      return;
    }
    setError(null);
    setLoading(true);
    try {
      const { error: err } = await supabase.auth.signInWithPassword({ email, password });
      if (err) throw err;
    } catch (err) {
      setError(err.message || 'Sign in failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: NAVY,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Open Sans', sans-serif",
    }}>
      <div style={{
        width: '100%',
        maxWidth: 400,
        padding: 40,
        background: WHITE,
        borderRadius: 16,
        boxShadow: '0 24px 48px rgba(0,0,0,0.2)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56,
            height: 56,
            margin: '0 auto 16px',
            background: NAVY,
            borderRadius: 12,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <span style={{ color: GOLD, fontSize: 20, fontWeight: 900, fontFamily: 'Merriweather, serif' }}>AG</span>
          </div>
          <div style={{ fontFamily: 'Merriweather, serif', fontWeight: 700, fontSize: 24, color: NAVY }}>AshGro</div>
          <div style={{ fontSize: 11, color: GOLD, letterSpacing: 3, textTransform: 'uppercase', marginTop: 4 }}>CRM</div>
        </div>

        <form onSubmit={handleSignIn}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: NAVY, marginBottom: 6 }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="you@example.com"
              style={{
                width: '100%',
                padding: '12px 14px',
                border: `1px solid ${BORDER}`,
                borderRadius: 8,
                fontSize: 14,
                color: NAVY,
                background: WHITE,
                boxSizing: 'border-box',
                outline: 'none',
              }}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: NAVY, marginBottom: 6 }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              style={{
                width: '100%',
                padding: '12px 14px',
                border: `1px solid ${BORDER}`,
                borderRadius: 8,
                fontSize: 14,
                color: NAVY,
                background: WHITE,
                boxSizing: 'border-box',
                outline: 'none',
              }}
            />
          </div>
          {error && (
            <div style={{
              marginBottom: 16,
              padding: '10px 14px',
              background: '#FEF2F2',
              border: `1px solid #FCA5A5`,
              borderRadius: 8,
              fontSize: 13,
              color: RED,
            }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px 20px',
              background: loading ? SLATE : NAVY,
              color: WHITE,
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: loading ? 'default' : 'pointer',
              fontFamily: 'inherit',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={{ marginTop: 24, fontSize: 12, color: SLATE, textAlign: 'center', lineHeight: 1.6 }}>
          Sign in with your AshGro account to access the CRM.
        </p>
      </div>
    </div>
  );
}
